import * as CONST from './constantsActions';
import { CLEAR_PASSWORD_DATA} from 'action-creators/user/password/constants';

export function responseConfig(config) {
  return {
    type: CONST.RESPONSE_CONFIG,
    config,
  };
}

export function responseIsLoggedIn(checkLogin) {
  return {
    type: CONST.CHECK_LOGIN,
    checkLogin,
  };
}

export function responseMetadata(metadata) {
  return {
    type: CONST.RESPONSE_META,
    metadata,
  };
}

export function responseAsset(asset) {
  return {
    type: CONST.RESPONSE_ASSET,
    asset,
  };
}

export function getTranslations(translations) {
  return {
    type: CONST.TRANSLATIONS,
    translations,
  };
}
export function setPlanSelectorTranslations(translations) {
  return {
    type: CONST.PLAN_SELECTOR_TRANSLATIONS,
    translations,
  };
}
export function setPlanSelectorAsset(asset) {
  return {
    type: CONST.PLAN_SELECTOR_ASSET,
    asset,
  };
}
export function setPlanSelectorOffers(offers) {
  return {
    type: CONST.PLAN_SELECTOR_OFFERS,
    offers,
  };
}

export function responseFavorites(favorites) {
  return {
    type: CONST.RESPONSE_FAVORITES,
    favorites,
  };
}

export function addFavorite(group) {
  return {
    type: CONST.FAVORITE_ADD,
    group,
  };
}

export function removeFavorite(group) {
  return {
    type: CONST.FAVORITE_REMOVE,
    group,
  };
}

export function user(user) {
  return {
    type: CONST.USERTYPE,
    user,
  };
}

export function showModal(modal) {
  return {
    type: CONST.SHOWMODAL,
    modal,
  };
}

export function removeModal(modalType) {
  return {
    type: CONST.REMOVE_MODAL,
    modalType,
  };
}

export function getFollowings() {
  return {
    type: CONST.GET_FOLLOWINGS,
  };
}

export function requestFollowings() {
  return {
    type: CONST.REQUEST_FOLLOWINGS,
  };
}

export function removeFollowing(userSocial) {
  return {
    type: CONST.FOLLOWING_REMOVE,
    userSocial,
  };
}

export function addFollowing(userSocial) {
  return {
    type: CONST.FOLLOWING_ADD,
    userSocial,
  };
}

export function clearFollowings() {
  return {
    type: CONST.CLEAR_FOLLOWINGS,
  };
}

export function unsuscribeConfirm() {
  return {
    type: CONST.UNSUSCRIBE_CONFIRM,
  };
}

export function errorNotControlledClear() {
  return {
    type: CONST.ERROR_NOT_CONTROLED_CLEAR,
  };
}

export function clearPasswordData(){
  return{
    type: CLEAR_PASSWORD_DATA,
  }
}
